import React from 'react';
import { useNavigate } from 'react-router-dom';
import { ReactComponent as StatusCode404Icon } from 'src/Images/icons/common/statusCode404.svg';

function StatusCode404() {
  const navigate = useNavigate();

  return (
    <div className="page-layout div-align-center div-flex-center div-flex-column rg-20">
      <div>
        <StatusCode404Icon className="status-code-empty-state-img div-align-center div-flex-center" />
      </div>
      <div className="heirarchy-structure-empty-state-container div-flex-column rg-10">
        <div className="text-xl text-semi-bold text-center">Page Not Found</div>
        <div className="text-grey text-sm div-align-center div-flex-column text-center">
          <span>
            The page you&#39;re looking for doesn&#39;t exist or may have been
            moved.
          </span>
        </div>
        <div
          className="text-underline-blue"
          onClick={() => navigate(-1)}
          role="button"
          tabIndex={0}
        >
          <div className="text-center text-sm">Go Back</div>
        </div>
      </div>
    </div>
  );
}

export default StatusCode404;
